// extracted by mini-css-extract-plugin
module.exports = {"proposal":"Proposal_proposal__84d2P","proposal__title":"Proposal_proposal__title__LY9xr"};